import React from 'react';
import { Text, FlexCrate } from '@perch-labs/shrike';
import { Switch, Route, Redirect } from 'react-router-dom';
import { CenterGridColumn } from 'styles';
import { routes, copyFor } from 'config';
import { RouterLocation } from 'types/shared';
import { BackLink } from 'components/back-link';
import { NavLinkTab } from 'components/navigation/nav-link-tab';
import { useAccountContext } from 'contexts/account';
import { AccountMethods } from './components/account-methods';
import { PlanMethods } from './components/plan-methods';
import { Content, StyledGrid, SubNav } from './payment-methods.style';

const { settings, paymentSettings, paymentWallet } = routes();
const getCopy = copyFor('settings.paymentInformation');

interface CenterProps {
  mobileFullWidth?: boolean;
  children: React.ReactNode;
}

interface Props {
  location: RouterLocation;
}

const Centered = ({ children, mobileFullWidth = false }: CenterProps) => (
  <StyledGrid mobileFullWidth={mobileFullWidth}>
    <CenterGridColumn>{children}</CenterGridColumn>
  </StyledGrid>
);

export const PaymentMethods = ({ location }: Props) => {
  const { selectedAccount } = useAccountContext();

  return (
    <>
      <BackLink
        to={location.state?.from || settings}
        location={location.state?.fromLabel}
      />
      <Centered>
        <Text
          data-testid="new-payment-methods"
          textStyle="heading800"
          tag="h1"
          margin={{ top: '24px' }}
        >
          {getCopy('title')}
        </Text>
        <Text color="secondary" margin={{ top: '8px', bottom: '8px' }}>
          {getCopy('subtitle', {
            accountNumber: selectedAccount.accountNumber,
          })}
        </Text>
      </Centered>
      <SubNav>
        <Centered>
          <FlexCrate height="64px">
            <NavLinkTab
              copy={getCopy('tabs.planMethods')}
              path={paymentSettings}
              padding="24px 8px"
              margin={{ right: '16px' }}
            />
            <NavLinkTab
              copy={getCopy('tabs.accountMethods')}
              path={paymentWallet}
              padding="24px 8px"
            />
          </FlexCrate>
        </Centered>
      </SubNav>
      <Content>
        <Centered mobileFullWidth={true}>
          <Switch>
            <Route path={paymentSettings} component={PlanMethods} />
            <Route path={paymentWallet} component={AccountMethods} />
            <Redirect to={paymentSettings} />
          </Switch>
        </Centered>
      </Content>
    </>
  );
};
